import { fetcher } from "helpers/fetcher";

import { TGetAccessRightListReq, TGetAccessRightListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getAccessRightList = async (payload?: TGetAccessRightListReq) => {
  return await fetcher<TGetAccessRightListRes, TGetAccessRightListReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_ACCESS_RIGHT_LIST,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_ACCESS_RIGHT_LIST.version,
        [API_HEADER.BU_ID]: payload?.idBu,
      },
      data: payload?.data,
    }
  );
};

export const queryGetAccessRightList = async (
  payload?: TGetAccessRightListReq
) => {
  return (await getAccessRightList(payload)).data;
};

queryGetAccessRightList._key = (payload?: TGetAccessRightListReq) => [
  ENDPOINT.MANAGEMENT.GET_ACCESS_RIGHT_LIST.url,
  payload,
];
